/* eslint-disable max-len */
import React, { FC } from 'react';
import { Form, Input, Select } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../../../core/redux';
import { projectsApiService } from '../../../../../api/projects/projectsApiService';
import { description, englishTitle, russianTitle, types } from '../DocumentProcessing';
import { getValidateCase } from '../../../helpers/helpers';
import Types from '../../../../../../types/types';

import s from './General.module.scss';
import { tablesSlice } from '../../../TablesSlice';

const { errorEngNameMessage, labelNames, initTabs } = Types;

type FieldType = {
  russianTitle?: string;
  englishTitle?: string;
  description?: string;
  types?: Array<string>;
};
const { setHasUnsavedChanges } = tablesSlice.actions;

export const General: FC = () => {
  const dispatch = useAppDispatch();
  const { editableTable, hasUnsavedChanges } = useAppSelector((state) => state.tablesSlice);
  const {
    data: docsTypesData,
    // isError: docsTypesIsError,
    // error: docsTypesError,
    // status: docsTypesStatus,
    // isLoading: docsTypesLoading,
    // isFetching: docsTypesIsFetching,
  } = projectsApiService.useGetDocsTypesQuery({ skip: 0, limit: 1000 });

  const {
    // key = '',
    project_name = '',
    mart_code = '',
    description: initdesc = '',
    doc_type = [],
    // date_creation = '',
    // сreated_by = '',
    // date_change = '',
    // author_changes = '',
    // status = '',
  } = editableTable;

  const descriptionOptions =
    (docsTypesData?.length && docsTypesData.map((o) => ({ value: o.id, label: o.display }))) || [];
  const handleSetHasChanges = () => {
    const hasChanges = { ...hasUnsavedChanges, [initTabs['general']]: true };
    const has = hasUnsavedChanges[initTabs['general']];
    if (!has) {
      dispatch(setHasUnsavedChanges(hasChanges));
    }
  };

  return (
    <div className={s.General}>
      <div className={s.content}>
        <div className={s.tabTitle}>
          <span>Основная информация</span>
        </div>

        <div className={s.fieldsWrapper}>
          <Form.Item<FieldType>
            label={labelNames['russianName']}
            name={russianTitle}
            initialValue={project_name}
            rules={[
              {
                required: true,
                message: 'Обязательно для заполнения',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  handleSetHasChanges();
                  const cond = getValidateCase(getFieldValue('russianTitle'), 'ru');
                  if (!value || cond) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Разрешен ввод только на русском языке'));
                },
              }),
            ]}
            className={s.field}
          >
            <Input placeholder={labelNames['russianName']} />
          </Form.Item>

          <Form.Item<FieldType>
            label={labelNames['englishName']}
            name={englishTitle}
            initialValue={mart_code}
            rules={[
              {
                required: true,
                message: 'Обязательно для заполнения',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  handleSetHasChanges();
                  const cond = getValidateCase(getFieldValue('englishTitle'), 'en');
                  if (!value || cond) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(errorEngNameMessage));
                },
              }),
            ]}
            className={s.field}
          >
            <Input placeholder={labelNames['englishName']} />
          </Form.Item>
        </div>

        <div className={s.fieldsWrapper}>
          <Form.Item<FieldType>
            label='Описание'
            name={description}
            className={s.field}
            initialValue={initdesc}
            rules={[
              () => ({
                validator() {
                  handleSetHasChanges();
                },
              }),
            ]}
          >
            <Input.TextArea placeholder='Описание' rows={4} showCount maxLength={3000} />
          </Form.Item>

          <Form.Item<FieldType>
            label='Тип документа'
            name={types}
            className={s.field}
            initialValue={doc_type.map((type) => type.id || type)}
            rules={[
              () => ({
                validator() {
                  handleSetHasChanges();
                },
              }),
            ]}
          >
            <Select
              maxTagTextLength={50}
              mode='multiple'
              placeholder='Типы документа'
              options={descriptionOptions}
              filterOption={(val, option) => {
                return option.label.toLocaleLowerCase().includes(val.toLocaleLowerCase());
              }}
            />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};
